// extracted by mini-css-extract-plugin
module.exports = {"row":"invoicesimplified_row__3AAtW","dueDateItem":"invoicesimplified_dueDateItem__1X2MP","btnCol":"invoicesimplified_btnCol__1lCIm"};